import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import deleteImg from '../../../styles/assets/delete-user-data.svg';
import updateImg from '../../../styles/assets/update-user-data.svg';

import './stylesDataConfirmation.css';

function StatusMessage({ isUpdateData }){

	const { t } = useTranslation();

	return(
		<div className='data-confirmation__container-status-message'>
			<img src={isUpdateData ? updateImg : deleteImg} alt='Message de fim' />
			<div className='data-confirmation__status-message'>
				<Typography variant='h3' style={{ fontWeight: 'bold', color: '#6d3196' }}>
						{ t('general.all_right') }
				</Typography>
				<Typography variant='subtitle1' style={{ textAlign: 'center' }}>
						{isUpdateData ? t('general.your_data_was_updated_successfully') : t('general.your_data_was_completely_removed')}
				</Typography>
			</div>
		</div>
	);
} 

export default StatusMessage;